// Placeholder shared assignee for every CVVC location, pending the real per-location Athena bucket
// names (the index-mapping sheet's Bucket/email column is marked "to be specified by CVVC").
export const CVVC_PLACEHOLDER_ASSIGNEE = "CVVC_PLACEHOLDER_BUCKET";

// Athena department EHR IDs pulled live from StrideCare's Athena instance and matched against the
// CVVC index-mapping sheet's location addresses.
export const departments = {
  "234": { name: "Charleston", assignee: CVVC_PLACEHOLDER_ASSIGNEE },
  "235": { name: "Summerville", assignee: CVVC_PLACEHOLDER_ASSIGNEE },
  "236": { name: "Mount Pleasant", assignee: CVVC_PLACEHOLDER_ASSIGNEE },
  "237": { name: "Walterboro", assignee: CVVC_PLACEHOLDER_ASSIGNEE },
  "238": { name: "Murrells Inlet", assignee: CVVC_PLACEHOLDER_ASSIGNEE },
  "239": { name: "Orangeburg", assignee: CVVC_PLACEHOLDER_ASSIGNEE },
};
